import { helpers } from 'vuelidate/lib/validators';

export const domainNameValidator = helpers.regex('alpha', /^[\w-]+\.\w+$/);
